import Checkbox from '@atlaskit/checkbox';
import React from 'react';

/**
 * This component is rendered when the databasesSelectionsPerformance experiment flag is enabled.
 * Input events are captured by the selections package for optimized performance.
 */
const SelectionsHeaderCheckbox = () => <Checkbox id="selections-header-checkbox" />;

export default SelectionsHeaderCheckbox;
